module.exports = new __parcel__URL__("logo_loire_atlantique_nautisme.293f7d1e.png").toString();